module.exports = __webpack_public_path__ + "static/logo-ABOMS-265a6e2a2a04982a0691a0e889683bf6.svg";